// extracted by mini-css-extract-plugin
export default {"overlay":"DescriptionModal_overlay__JkRk5","modal":"DescriptionModal_modal__5VCju","content":"DescriptionModal_content__OYlmJ","closeButton":"DescriptionModal_closeButton__gPp5B"};